/* ============================================================
   carska-pdp.js — JEDEN skrypt stron produktów (PDP).
   Zastępuje <script> kopiowany do sekcji carska-pdp-*.liquid.
   Ładowany w theme.liquid (defer) tylko dla template.name == 'product'.

   Zakres: (1) miniatury galerii (slot pod karuzelę 6 obrazów),
   (2) wybór tieru ilości (#packs → #variant-input, cena CTA i paska sticky),
   (3) przełącznik upsellu (#upsell-btn, data-variant / data-label),
   (4) wysyłka formularza z aktywnym upsellem: dwie pozycje jednym żądaniem.
   Bez upsellu formularz przechwytuje assets/carska-cart.js (drawer koszyka),
   dokładnie tak, jak działało to przed unifikacją 2026-09-05.
   ============================================================ */
(function () {
  'use strict';
  /* Bramka: dziala wylacznie na sekcjach oznaczonych data-ck-pdp (21 stron pojedynczych).
     Flagowiec, zestawy i multipacki maja nadal wlasne skrypty inline; podwojne
     nasluchiwanie na tych samych id anulowaloby przelacznik upsellu. */
  if (!document.querySelector('[data-ck-pdp]')) return;
  function byId(id) { return document.getElementById(id); }
  function setPrice(txt) {
    if (!txt) return;
    var a = byId('atc-price') || byId('cta-price');
    if (a) a.textContent = txt;
    var s = byId('sticky-price');
    if (s) s.textContent = txt;
  }

  /* 1. Miniatury galerii */
  var thumbs = byId('thumbs');
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      var img = byId('gallery-img');
      if (img && b.dataset.src) img.src = b.dataset.src;
    });
  }

  /* 1b. Strzałka paska miniatur: widoczna tylko, gdy miniatury nie mieszczą się w szerokości */
  var strip = document.querySelector('.gallery-strip');
  if (thumbs && strip) {
    var next = strip.querySelector('[data-gallery-next]');
    function syncNext() { if (!next) return; next.hidden = thumbs.scrollWidth - thumbs.clientWidth - thumbs.scrollLeft < 8; }
    if (next) {
      next.addEventListener('click', function () { thumbs.scrollBy({ left: thumbs.clientWidth * 0.8, behavior: 'smooth' }); });
      thumbs.addEventListener('scroll', syncNext, { passive: true });
      window.addEventListener('resize', syncNext);
      syncNext();
    }
  }

  /* 1c. Przyklejone zdjęcie na desktopie: gdy kolumna zdjęcia jest wyższa niż okno,
     przesuwamy punkt przyklejenia w górę tak, by DÓŁ zdjęcia kończył się nad dolną krawędzią ekranu. */
  var wrap = document.querySelector('.pdp[data-ck-pdp] .gallery-wrap');
  if (wrap) {
    var syncSticky = function () {
      if (window.innerWidth <= 900) { wrap.style.top = ''; return; }
      var navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ck-nav-h'), 10) || 72;
      var topMin = navH + 12;
      var free = window.innerHeight - wrap.offsetHeight - 16;
      wrap.style.top = (free < topMin ? free : topMin) + 'px';
    };
    syncSticky();
    window.addEventListener('resize', syncSticky);
    var gimg = document.getElementById('gallery-img');
    if (gimg) gimg.addEventListener('load', syncSticky);
  }

  /* 2. Tiery ilości */
  var packs = byId('packs');
  function selectPack(l) {
    if (!l || l.dataset.oos === '1') return;
    packs.querySelectorAll('.pack').forEach(function (x) { x.classList.remove('selected'); });
    l.classList.add('selected');
    var r = l.querySelector('input[type=radio]');
    if (r && !r.checked) r.checked = true;
    var vi = byId('variant-input');
    if (vi && l.dataset.variant) vi.value = l.dataset.variant;
    setPrice(l.dataset.price);
  }
  if (packs) {
    packs.addEventListener('click', function (e) { selectPack(e.target.closest('.pack')); });
    packs.addEventListener('change', function (e) { selectPack(e.target.closest('.pack')); });
  }

  /* 3. Upsell (toggle) */
  var up = byId('upsell-btn');
  if (up) {
    /* Etykieta powrotna: wiekszosc sekcji nie ma data-label, wiec bez tego drugie
       klikniecie kasowalo napis na przycisku (defekt znaleziony 2026-09-05 na Betainie). */
    if (!up.dataset.label) up.dataset.label = up.textContent.trim();
    up.setAttribute('aria-pressed', 'false');
    up.addEventListener('click', function () {
      var on = up.dataset.active === '1';
      up.dataset.active = on ? '0' : '1';
      up.setAttribute('aria-pressed', on ? 'false' : 'true');
      up.textContent = on ? up.dataset.label : '✓ Dodane do zamówienia';
      up.classList.toggle('is-on', !on);
    });
  }

  /* 4. Formularz z aktywnym upsellem */
  var form = byId('atc-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!up || up.dataset.active !== '1' || !up.dataset.variant) return;
      e.preventDefault();
      var vi = byId('variant-input');
      var main = vi ? parseInt(vi.value, 10) : NaN;
      var items = [{ id: main, quantity: 1 }, { id: parseInt(up.dataset.variant, 10), quantity: 1 }];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    });
  }
})();
